<div *ngIf="!(paymentSessionExpired$ | async); else paymentExpired" class="pre-auth-container">
  <mat-toolbar role="toolbar" class="gb-dialog-header">
    <h2 mat-dialog-title translate="PRE_AUTH.HEADER"></h2>
    <button mat-icon-button mat-dialog-close aria-label="Cancel">
      <mat-icon mat-list-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-dialog-content
    *ngIf="{
      pageShowing: pageShowing$ | async,
      selectedcPaymentMethodUuid: selectedcPaymentMethodUuid$ | async,
      isVolunteer: isVolunteer$ | async,
      isSaas: isSaas$ | async
    } as obs"
  >
    <div class="pre-auth-info">
      <p
        *ngIf="obs.isVolunteer; else guestMessage"
        translate="PRE_AUTH.MESSAGE_VOLUNTEER"
        [translateParams]="{ guest: selectedProfileFirstName$ | async }"
      ></p>
      <ng-template #guestMessage>
        <p translate="PRE_AUTH.MESSAGE"></p>
        <p [translate]="obs.isSaas ? 'PRE_AUTH.MESSAGE_AMOUNT_OWING_SAAS' : 'PRE_AUTH.MESSAGE_AMOUNT_OWING'"></p>
      </ng-template>
    </div>

    <!-- Digital wallet -->
    <gb-digital-wallets></gb-digital-wallets>

    <!-- Manual card add -->
    <gb-add-card [showBackButton]="false" [shouldShowSaveCardForFutureUsage]="false"></gb-add-card>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button
      mat-raised-button
      color="primary"
      (click)="onAddCard()"
      [disabled]="(paymentElementReady$ | async) === false"
      translate="PRE_AUTH.SUBMIT"
      class="w-100"
    ></button>
    <gb-powered-by-stripe [darkTheme]="isDarkTheme"></gb-powered-by-stripe>
  </mat-dialog-actions>
</div>

<ng-template #paymentExpired>
  <gb-payment-expired></gb-payment-expired>
</ng-template>
